import { motion, useReducedMotion } from "framer-motion";

// Soft radial glow that grows and warms as `stage` progresses toward `total`.
export const Orb = ({ stage = 0, total = 8, size = 460 }) => {
  const reduce = useReducedMotion();
  const p = Math.min(stage / total, 1);
  const scale = 0.55 + p * 1.25;
  const opacity = 0.22 + p * 0.6;

  return (
    <motion.div
      aria-hidden="true"
      data-testid="glowing-orb"
      className="pointer-events-none fixed left-1/2 top-1/2 -z-10 -translate-x-1/2 -translate-y-1/2 rounded-full"
      style={{
        width: size,
        height: size,
        filter: "blur(120px)",
        background:
          "radial-gradient(circle at 40% 35%, #FFD700 0%, #FF8A5B 45%, #FF6B6B 75%, rgba(255,107,107,0) 100%)",
      }}
      initial={{ scale: 0.5, opacity: 0.15 }}
      animate={
        reduce
          ? { scale, opacity }
          : { scale, opacity, y: [0, 18, 0] }
      }
      transition={{
        scale: { duration: 1.4, ease: "easeOut" },
        opacity: { duration: 1.4, ease: "easeOut" },
        y: { duration: 7, repeat: Infinity, ease: "easeInOut" },
      }}
    />
  );
};
